import { ButtonType, DialogFooterButtonsWidget, TextLinkWidget } from '@tableau/widgets';
import * as React from 'react';
import { connect, MapDispatchToProps } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';
import { DialogFieldParentStyle } from '~src/commonInfra/dialogs/style/DialogStyles';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { DeleteSiteEncryptionKeyService } from '~src/kmsInOnline/services/DeleteSiteEncryptionKeyService';
import { learnMoreStyle } from '~src/settings/styles/CommonStyles';

import { getExtractEncryptionKeyRequest } from '../actions/GetExtractEncryptionKeyRequestAction';



export interface CMEKEncryptionKeyDeleteViewOwnProps {
    closeDialog: CloseAndDismiss;
}

export interface CMEKEncryptionKeyDeleteViewDispatchProps {
    retrieveExtractEncryptionKey: () => void;
}

export type CMEKEncryptionKeyDeleteViewProps = CMEKEncryptionKeyDeleteViewOwnProps & CMEKEncryptionKeyDeleteViewDispatchProps;

export interface CMEKEncryptionKeyDeleteViewState {
    confirmationText: string;
    isDeleting: boolean;
}


export class CMEKEncryptionKeyDeleteViewComponent extends React.PureComponent<CMEKEncryptionKeyDeleteViewProps, CMEKEncryptionKeyDeleteViewState> {

    constructor(props: CMEKEncryptionKeyDeleteViewProps) {
        super(props);
        this.state = {
            confirmationText: '',
            isDeleting: false
        };
    }


    public render(): JSX.Element {
        return (
            <>
            <div style={DialogFieldParentStyle}>
                <span>
                    {Messages.extractEncryption_CMEKKeyDeleteKeyDialog_Description()}
                    <TextLinkWidget
                        testId={'cmek-key-delete-key-dialog-learn-more'}
                        href={HelpService.getServerHelpUrlByCategory('customer-managed-encryption-keys')}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={learnMoreStyle}
                    >
                    {Messages.learnMore()}
                    </TextLinkWidget>
                </span>
            </div>
            <div style={DialogFieldParentStyle}>
                {Messages.extractEncryption_CMEKKeyDeleteKeyDialog_Instructions()}
            </div>
            <div style={{display:'block', textAlign: 'center', marginBottom: CommonStyles.Sizes.LargeSpace}}>
                {Messages.extractEncryptionTOLKeyDeletionDialogConfirmation()}
                <input value={this.state.confirmationText} onChange={e => this.setState({confirmationText: e.target.value})} type={'text'}
                    style={{display: 'block', position: 'relative', margin: '0 auto', width: '50%'}}/>
            </div>
            <br></br>
            <div style={{ position: 'relative' }}>
                <DialogFooterButtonsWidget
                    buttons={[
                        {
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            onClick: this.props.closeDialog.close,
                            testId: 'cancel-button'
                        },
                        {
                            buttonType: ButtonType.Primary,
                            showSpinner: this.state.isDeleting,
                            children: Messages.extractEncryption_CMEKKeyDeleteKeyDialog_DeleteButton(),
                            onClick: () => this.deleteEncrpytionKey(),
                            disabled: this.state.confirmationText !== Messages.extractEncryption_CMEKKeyDeleteKeyDialog_confirmation(),
                            testId: 'delete-button'
                        }
                    ]}
                />
            </div>
        </>
        );
    }

    private deleteEncrpytionKey() {
        this.setState({isDeleting: true}, () => {
          DeleteSiteEncryptionKeyService.deleteSiteEncryptionKey()
          .then(() => {
              ToasterService.instance.pop({ type: ToastType.Success, text: Messages.extractEncryptionTOLKeyDeletionSucceeded() });
          })
          .catch(() => {
              ToasterService.instance.pop({ type: ToastType.Error, text: Messages.extractEncryptionTOLKeyDeletionFailed() });
          })
          .finally(() => {
              this.setState({isDeleting: false});
              this.props.closeDialog.close();
              this.props.retrieveExtractEncryptionKey();
          });
          });
      }
}

const mapDispatchToProps: MapDispatchToProps<CMEKEncryptionKeyDeleteViewDispatchProps, {}> =
  (dispatch) => bindActionCreators({
    retrieveExtractEncryptionKey: getExtractEncryptionKeyRequest
  },
  dispatch);

export const CMEKEncryptionKeyDeleteView: React.ComponentClass<CMEKEncryptionKeyDeleteViewOwnProps> =
  connect(undefined, mapDispatchToProps)(CMEKEncryptionKeyDeleteViewComponent);